export default () => ({
	requestInProgress: false,
	logout(e) {
		e.preventDefault();

		if (this.requestInProgress) {
			return;
		}

		this.requestInProgress = true;
		fetch("/api/logout", {
			method:"POST",
			headers: {
				accept: "aplication/json",
			},
		})
		.then(resp => resp.json())
		.then(data => {
			console.log(data);
			window.location.reload();
		})
		.catch(err => {
			console.error(err);
		}).finally(() => {
			this.requestInProgress = false;
		});
	}
});
